import { render, staticRenderFns } from "./instPreWin.vue?vue&type=template&id=5cf0560f&scoped=true"
import script from "./instPreWin.vue?vue&type=script&lang=js"
export * from "./instPreWin.vue?vue&type=script&lang=js"
import style0 from "./instPreWin.vue?vue&type=style&index=0&id=5cf0560f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0560f",
  null
  
)

export default component.exports